import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { pipe, tap, Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';
import { StorageService } from '../services/storage.service';
import { Environment } from '../environment';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService,
                private storageService: StorageService,
                private environment: Environment,
                private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.authService.loadToken()).pipe(
            switchMap(token => {
                const headers = request.headers
                    .set('Authorization', 'Bearer ' + token)
                    .append('Content-Type', 'application/json')
                    .append('X-App-Version', this.environment.getVersionNumber())
                const reqClone = request.clone({
                    headers
                });
                return next.handle(reqClone).pipe(tap(() => {},
                                                      (err: any) => {
                                                          if (err instanceof HttpErrorResponse) {
                                                              if (err.status === 401) {
                                                                  // See if we can retry the request
                                                                  this.authService.logout();
                                                                  this.router.navigateByUrl('/login');
                                                              }
                                                          }
                                                      }));
            }));
    }
}
